<template>
  <div class="form-group">
    <label v-if="label">{{ label }}</label>
    <input
      :class="{
        'is-invalid': field.$error,
        'is-valid': !field.$invalid && value && value.length > 1,
      }"
      :maxlength="resolvedMaxLength"
      :placeholder="placeholder"
      :type="type ? type : 'text'"
      :value="value"
      class="form-control"
      v-on:input="updateValue($event.target.value)"
    />
    <div v-if="showmaxLengthAlert" class="text-danger text-right">
      <small> {{ value.length }}/{{resolvedMaxLength}}</small>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "label",
    "type",
    "placeholder",
    "field",
    "value",
    "vmask",
    "maxLength",
  ],
  methods: {
    updateValue: function (value) {
      this.$emit("input", value);
    },
  },
  computed: {
    resolvedMaxLength() {
      return this.maxLength || 255;
    },
    showmaxLengthAlert() {
      if (!this.value) return false;

      return this.value.length > this.resolvedMaxLength * 0.85;
    },
  },
};
</script>
